// extracted by mini-css-extract-plugin
export default {"container":"Labelled_container__r79Vk","label":"Labelled_label__Iz9-s"};